<template>
  <div class="course-list">
    <div class="related-lecture">
      <div class="title">전체 동화 <span>{{ isCourseCount }}</span>권</div>
      <div class="button">
        <img v-show="isTwoTrackVisible" v-if="!isTwoTrack" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/twotrack2.png" width="60" height="21" @click="twoTrack" />
        <img v-show="isTwoTrackVisible" v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/twotrack2-active.png" width="60" height="21" @click="twoTrack" />
        <img v-if="!isAutoPlay" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/autoplay2.png" width="60" height="21" @click="autoPlay" />
        <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/autoplay2-active.png" width="60" height="21" @click="autoPlay" />
      </div>
    </div>
    <ul class="related-lecture-list">
      <li class="item-group" v-for="course in courseList" v-show="course.isTrack === '0' || (course.isTrack === '1' && isTwoTrack)">
        <div class="course-title">
          <div class="word_comma_1" v-bind:class="{'selected' : course.related_course_no === courseNo }" @click="play(course.related_course_no)">{{ course.course_name }}</div>
          <div class="keyword-info word_comma_1" @click="play(course.related_course_no, false)">{{ course.keyword }}</div>
        </div>
        <div class="time"><img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/preview/clock-gray.png" width="11" height="11">{{ course.course_time }}</div>
        <div class="count"><img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/preview/view-gray.png" width="12" height="8">{{ course.view_count }}</div>
        <div class="isTrack"><img v-show="course.isTrack === '1'" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/is-track.png" width="12" height="12" @click="twoTrack" /></div>
      </li>
    </ul>
  </div>
</template>

<script>
import * as ajax from "../../utils/ajax";
import * as utils from "../../utils/utils";
import * as biz from '../../utils/biz'

export default {
  name: 'CourseList',
  props: {
    courseNo: Number
  },
  data() {
    return {
      courseNumber: 0,
      courseList: [],
      isTwoTrack: false,
      isAutoPlay: false,
      isGetList: true
    }
  },
  mounted() {
    this.getTwoTrackList();
  },
  methods: {
    twoTrack() {
      this.isTwoTrack = !this.isTwoTrack;
      const params = {
        courseNumber: this.courseNumber,
        courseList: this.courseList,
        isTwoTrack: this.isTwoTrack
      };
      switch(utils.deviceInfo()) {
        case "Android":
          window.listenApp.isTwoTrack(JSON.stringify(params));
          break;
        case "iOS":
          window.webkit.messageHandlers.isTwoTrack.postMessage(params);
          break;
      }
    },
    autoPlay() {
      this.isAutoPlay = !this.isAutoPlay;
      const params = {
        courseNumber: this.courseNumber,
        courseList: this.courseList,
        isAutoPlay: this.isAutoPlay
      };
      switch(utils.deviceInfo()) {
        case "Android":
          window.listenApp.isAutoPlay(JSON.stringify(params));
          break;
        case "iOS":
          window.webkit.messageHandlers.isAutoPlay.postMessage(params);
          break;
      }
    },
    play(course_no) {
      biz.playAudioPlayer(course_no);
      // 재생 시 화면 맨 위로
      document.querySelector('div.basic-player').scrollTop = 0;
    },
    playEnded() {
      let nextCourseNo = false;
      const courseNumber = this.courseNumber + 1;

      // 전체동화재생이 활성화 되어 있는 경우에는 다음동화 재생
      if (this.isAutoPlay) {

        // Two Track 이 활성회 되어 있는 경우에는 Two Track 재생, 아닌 경우 다음동화 재생
        if (this.isTwoTrack) {
          if (this.courseList[courseNumber]) {

            // Two Track 재생 시 동화 리스트 갱신 안함
            if (this.courseList[courseNumber].isTrack === '1') {
              this.isGetList = false;
            }
            nextCourseNo = this.courseList[courseNumber].related_course_no;
          }
        } else {
          for (let item = courseNumber; item < this.courseList.length; item++) {
            if (this.courseList[item].isTrack === '0') {
              nextCourseNo = this.courseList[item].related_course_no;
              break;
            }
          }
        }

        biz.playAudioPlayer(nextCourseNo);
      }
    },
    getTwoTrackList() {
      ajax.Get(this, "/api/contents/relate/twotrack/" + this.courseNo, function(ref, data) {
        if (ref.isGetList) {
          for (let item in data) {
            if (data[item].related_course_no === ref.courseNo) {
              ref.courseNumber = Number(item);
            }
            if (data[item].keyword != null) {
              const keywords = data[item].keyword.split(",");
              data[item].keyword = "";
              for (let index in keywords) {
                data[item].keyword += "#"+keywords[index].replace(/\s/g,"") + " ";
              }
            }
          }
          ref.courseList = data;
          ref.isTwoTrack = false;
          ref.isAutoPlay = false;
        } else {
          for (let item in ref.courseList) {
            if (ref.courseList[item].related_course_no === ref.courseNo) {
              ref.courseNumber = Number(item);
            }
          }
        }
        ref.isGetList = true;
      });
    }
  },
  computed: {
    isTwoTrackVisible() {
      let visible = false;

      for (const item of this.courseList) {
        // Two Track 동화가 있는 경우에만 보임.
        if (item.isTrack === "1") {
          visible = true;
          break;
        }
      }
      return visible;
    },
    isCourseCount() {
      let count = 0;

      for (const item of this.courseList) {
        // Two Track 동화가 있는 경우에만 보임.
        if (item.isTrack === "0") {
          count++;
        }
      }
      return count;
    },
    isTwoTrackCount() {
      let count = 0;

      for (const item of this.courseList) {
        // Two Track 동화가 있는 경우에만 보임.
        if (item.isTrack === "1") {
          count++;
        }
      }
      return count;

    }
  },
  watch: {
    'courseNo': function(val, oldVal) {
      if (!this.isTwoTrack) {
        this.isGetList = true;
      }
      this.getTwoTrackList();
    }
  },
  filters: {
    minuteToStringFormat(value) {
      return utils.minuteToStringFormat(value);
    },
    thousandSeparator(value) {
      return utils.thousandSeparator(value);
    },
    convertSchoolGrade(value) {
      return utils.convertSchoolGrade(value);
    }
  },
}
</script>

<style scoped lang="scss">
div.course-list {
  padding: 24px;

  div.related-lecture {
    margin: 0 auto;
    display: flex;

    div.title {
      flex: 1;
      font-size: $font-base12;
      font-weight: $font-weight500;

      span {
        color: $primary-color;
      }
    }

    div.button {
      width: 125px;
      display: flex;
      justify-content: flex-end;

      img:first-child {
        margin: 0 5px 0 0;
      }
    }
  }

  ul.related-lecture-list {
    list-style: none;
    padding: 0;
    margin: 16px 0;
    font-size: $font-base14;

    li.item-group {
      display: flex;
      justify-content: space-between;
      height: 50px;
      //line-height: 44px;

      div.course-title {
        flex: 1;
        margin: 0 5px 0 0;

        div.word_comma_1 {
          font-weight: $font-weight500;
        }
        div.selected {
          color: $primary-color;
        }
        div.keyword-info {
          //display: flex;
          justify-content: flex-start;

          font-size: 11px;
          color: #fd7e2d;
        }
      }
      div.time {
        width: 55px;
        margin: 0 5px 0 0;
        font-size: $font-base12;

        img {
          margin: 0 5px 0 0;
        }
      }
      div.count {
        width: 40px;
        font-size: $font-base12;

        img {
          margin: 0 5px 0 0;
        }
      }
      div.isTrack {
        width: 12px;
      }

    }
  }

  div.related-lecture-button {
    margin: 20px 0;
    text-align: center;
    font-size: $font-base14;
    color: #5b5a5a;
    padding-top: 13px;
    border-top: 1px solid #ececec;

    ion-icon {
      margin-left: 8px;
    }
  }
}
</style>
